import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Optional, Output } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FirmanteNif } from '../../../models/firmante-nif';
import { FormularioDocumentoService } from '../../../services/formulario-documento.service';
import { FormularioValidacionesDocsService } from '../../../services/formulario-validaciones-docs.service';
import { DatosConfiguracionDocumentosService } from '../../../services/datos-configuracion-documentos.service';
import { MODO_ENVIO_SIMPLE } from '../../../services/modo-envio-simple.token';

@Component({
  selector: 'app-configuracion-firmas-tipo-firma',
  templateUrl: './configuracion-firmas-tipo-firma.component.html',
  styleUrls: ['./configuracion-firmas-tipo-firma.component.css']
})
export class ConfiguracionFirmasTipoFirmaComponent implements OnInit, OnDestroy {

  @Output() cambioIndex: EventEmitter<number> = new EventEmitter<number>();
  @Input() firmante: FirmanteNif;

  /** En Envio simple se ocultan las opciones Validador y Sin firma. */
  readonly modoEnvioSimple: boolean;

  private tipoFirmaSubscription?: Subscription;

  constructor(public formularioDocumentoService: FormularioDocumentoService,
              public formularioValidacionesDocsService: FormularioValidacionesDocsService,
              private datosConfiguracionDocumentosService: DatosConfiguracionDocumentosService,
              @Optional() @Inject(MODO_ENVIO_SIMPLE) modoEnvioSimple: boolean) {
    this.modoEnvioSimple = modoEnvioSimple ?? false;
  }

  ngOnInit(): void {
    this.notificarCambioTipoFirma();
    this.tipoFirmaSubscription = this.tipoFirma?.valueChanges.subscribe(() => {
      this.validarFirmaAlCambiarTipo();
      this.notificarCambioTipoFirma();
    });
  }

  ngOnDestroy(): void {
    this.tipoFirmaSubscription?.unsubscribe();
    this.notificarCambioTipoFirma();
  }

  get formFirma(): FormGroup {
    return this.formularioDocumentoService.getFirmasGroup(this.firmante.tipoFirmante.codigo)!;
  }

  get firmantesNif(){ return this.formularioDocumentoService.formularioDocumento.controls['firmantesNif'] as FormArray}
  get tipoFirma(){ return this.formFirma.get('tipoFirma') }

  obtenerIndexNifArray(): number {
    return this.formularioDocumentoService.firmantesNif.value.findIndex(
      (x: FirmanteNif) => x.tipoFirmante.codigo === this.firmante.tipoFirmante.codigo
    );
  }

  private notificarCambioTipoFirma(): void {
    this.datosConfiguracionDocumentosService.transferirDatosValidador(true);
  }

  private validarFirmaAlCambiarTipo(): void {
    this.formFirma.markAsTouched();
    this.formFirma.updateValueAndValidity();
  }
}
